import React, { useEffect, useState } from "react";
import { getFaqData } from "services/_faq";
import Spondyloarthritis from "./components/Spondyloarthritis";

const FAQPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [faqData, setFaqData] = useState([]);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const initialData = async () => {
    const response = await getFaqData();
    if (response.isSuccess) {
      setFaqData(response.data);
    }
  };

  useEffect(() => {
    initialData();
  }, []);

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <div className="body_overly"></div>

      <section className="py-[40px]">
        <div className="container">
          <h1 className="heading ">Find The Answers You Need</h1>

          <div className="accordion_container mt-[50px]">
            {faqData.length > 0 ? (
              faqData.map((faq, index) => {
                return (
                  <>
                    <div
                      className="accordion_box border-gray-200 md:mb-[20px] mb-[15px]"
                      key={faq.id}
                    >
                      <button
                        className="flex !text-[#000] justify-between items-center w-full text-left text-gray-900 font-medium md:py-[12px] py-[8px] md:px-[16px] px-[12px]"
                        onClick={() => toggleAccordion(index)}
                      >
                        <span className="text-[18px] font-[600]">
                          {index + 1}. {faq.question}
                        </span>
                        <svg
                          className={`w-5 h-5 transition-transform ${
                            activeIndex === index ? "rotate-180" : ""
                          }`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </button>
                      {activeIndex === index && (
                        <div className="px-4 pb-3 pt-[15px] text-[18px] font-[400] text-[#3C4049] bg-[#fff]">
                          <p className="text-[#000D44] font-[400] ">
                            {faq.answer}
                          </p>
                        </div>
                      )}
                    </div>
                  </>
                );
              })
            ) : (
              <>
                <h1 className="text-center">No Data found</h1>
              </>
            )}
          </div>
        </div>
      </section>
      <Spondyloarthritis />
    </div>
  );
};

export default FAQPage;
